import { render } from "./BaseDialog.vue?vue&type=template&id=3f910a34&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=3f910a34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f910a34"]])

export default __exports__